<template>
  <div class="footer">
    <van-tabbar v-model="active">
      <van-tabbar-item safe-area-inset-bottom v-for="(tab, index) in tabbar" :to="tab.path" :key="index">
        <div class="icon"><span :class="tab.icon"></span></div>
        <div class="font">{{tab.name}}</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>

export default {
  name:'',
  data(){
    return{
      active: 0,
      tabbar: [
        {
          name: '首页',
          path: '/channelIndex',
          pathName: 'channelIndex',
          icon:'el-icon-s-home',//'📅'
          // icon: {
          //     active: require('@/assets/images/user/ordered.png'),
          //     inactive: require('@/assets/images/user/order.png'),
          // },
        },
        {
          name: '当前任务',
          path: '/channelHome',
          pathName: 'channelHome',
          icon:'el-icon-aim',//'📅'
          // icon: {
          //     active: require('@/assets/images/user/ordered.png'),
          //     inactive: require('@/assets/images/user/order.png'),
          // },
        },
        {
            name: '历史任务',
            path: '/channelHistory',
            pathName: 'channelHistory',
            icon:'el-icon-finished',//'🕒'
            // icon: {
            //     active: require('@/assets/images/user/customered.png'),
            //     inactive: require('@/assets/images/user/customer.png'),
            // },
        },
        {
          name: '我的',
          path: '/channelMy',
          pathName: 'channelMy',
          icon:'el-icon-user-solid',//'👤'
          // icon: {
          //     active: require('@/assets/images/user/meed.png'),
          //     inactive: require('@/assets/images/user/me.png'),
          // },
        }
      ]
    }
  },
  methods:{
    setActive(name){
      this.tabbar.forEach((tab, i) => {
        if (tab.pathName == name) {
          this.active = i;
          return false;
        }
      });
    }
  },
  created(){
    const toName = this.$route.name;
    this.setActive(toName);
  }
}
</script>
<style lang="scss">

</style>